import { EditPage, HasOne, NavigateBackButton } from '@contember/admin'
import * as React from 'react'
import { LinkForm, SeoForm } from '../forms'

export const OuthPage = (
	<EditPage
		pageName="outh"
		entity="Site(slug = $site)"
		rendererProps={{
			title: 'Outh page',
			navigation: <NavigateBackButton to="pageList">Pages</NavigateBackButton>,
		}}
	>
		<HasOne field="outhPage">
			<LinkForm />
			<SeoForm />
		</HasOne>
	</EditPage>
)
